import React from 'react';

import Switch from '@mui/material/Switch';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

function EventCard(props) {
  return (
    <>
      <div className="w-[350px] max-sm:w-[310px] h-[185px] flex flex-col justify-between rounded-[37px] border-1 border-white bg-white shadow-lg my-5 mx-2 p-5  hover:scale-105 transition ease 1s">
        <div className="flex flex-row justify-between">
          <div>
            <h6 className="font-bold">{props.title}</h6>
            <span className="text-[#B7B7B7]">{props.description}</span>
          </div>
          <div>
            <Switch />
          </div>
        </div>
        <div className="flex flex-row justify-between ">
          <div className="flex justify-center items-center p-2 gap-2">
            <AccessTimeIcon />
            <span className="text-[#B7B7B7]">{props.time}</span>
          </div>
          <div>
            <AvatarGroup max={4}>
              {props.avatars.map((avatar, index) => (
                <Avatar key={index} alt={avatar.name} src={avatar.src} />
              ))}
            </AvatarGroup>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventCard;
